module.exports = __webpack_public_path__ + "media/images/winner--right-471381272f3843273205bb213a471b4c.png";